import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddressEntityType } from 'types/ApiResponse'
import {
  StyledDataColumn,
  StyledDataContainer,
  StyledDataProperty,
  StyledHeader,
  StyledLine,
  StyledPropertyLabel,
  StyledPropertyValue,
  StyledSectionContainer,
} from '../PropertyInfo.styled'

const OwnershipInfo = (props: any) => {
  const { propertyData }: { propertyData: AddressEntityType } = props
  const { t } = useTranslation()

  return (
    <StyledSectionContainer>
      <StyledHeader>{t('addressModal.headers.ownership')}</StyledHeader>
      <StyledDataContainer>
        <StyledDataColumn>
          <StyledDataProperty>
            <StyledPropertyLabel>
              {t('newAddressModal.objectDataTab.ownership')}
            </StyledPropertyLabel>
            <StyledPropertyValue>
              {propertyData?.propertyDetails?.ownership
                ? t(`ownership.${propertyData?.propertyDetails?.ownership?.toLowerCase()}`)
                : '—'}
            </StyledPropertyValue>
          </StyledDataProperty>
        </StyledDataColumn>
        <StyledDataColumn>
          <StyledDataProperty>
            <StyledPropertyLabel>
              {t('newAddressModal.objectDataTab.groundLeaseActualRent')}
            </StyledPropertyLabel>
            <StyledPropertyValue>
              {propertyData?.propertyDetails?.groundLeaseActualRent
                ? `${propertyData?.propertyDetails?.groundLeaseActualRent} ${t(
                    'newAddressModal.objectDataTab.groundLeaseActualRent.unit'
                  )}`
                : '—'}
            </StyledPropertyValue>
          </StyledDataProperty>
          <StyledDataProperty>
            <StyledPropertyLabel>
              {t('newAddressModal.objectDataTab.groundLeaseRemainingTerm')}
            </StyledPropertyLabel>
            <StyledPropertyValue>
              {propertyData?.propertyDetails?.groundLeaseRemainingTerm
                ? `${propertyData?.propertyDetails?.groundLeaseRemainingTerm} ${t(
                    'newAddressModal.objectDataTab.groundLeaseRemainingTerm.unit'
                  )}`
                : '—'}
            </StyledPropertyValue>
          </StyledDataProperty>
        </StyledDataColumn>
      </StyledDataContainer>
      <StyledLine />
    </StyledSectionContainer>
  )
}

export default OwnershipInfo
